import ClickableMetric from "./ClickableMetric";

interface BusinessMetricsProps {
  prospectCount?: number;
  customerCount?: number;
  testimonialCount?: number;
  caseStudyCount?: number;
  awardCount?: number;
  className?: string;
  organizationId: string;
  segmentId?: string;
  propositionId?: string;
}

export default function BusinessMetrics({
  prospectCount = 0,
  customerCount = 0,
  testimonialCount = 0,
  caseStudyCount = 0,
  awardCount = 0,
  className = "",
  organizationId,
  segmentId,
  propositionId,
}: BusinessMetricsProps) {
  return (
    <div className={`grid grid-cols-2 md:grid-cols-5 gap-4 ${className}`}>
      <ClickableMetric
        value={prospectCount}
        label="Prospects"
        icon="🎯"
        color="text-blue-600"
        bgColor="bg-blue-50"
        organizationId={organizationId}
        metricType="prospects"
        segmentId={segmentId}
        propositionId={propositionId}
      />
      <ClickableMetric
        value={customerCount}
        label="Customers"
        icon="🤝"
        color="text-green-600"
        bgColor="bg-green-50"
        organizationId={organizationId}
        metricType="customers"
        segmentId={segmentId}
        propositionId={propositionId}
      />
      <ClickableMetric
        value={testimonialCount}
        label="Testimonials"
        icon="💬"
        color="text-purple-600"
        bgColor="bg-purple-50"
        organizationId={organizationId}
        metricType="testimonials"
        segmentId={segmentId}
        propositionId={propositionId}
      />
      <ClickableMetric
        value={caseStudyCount}
        label="Case Studies"
        icon="📄"
        color="text-orange-600"
        bgColor="bg-orange-50"
        organizationId={organizationId}
        metricType="case_studies"
        segmentId={segmentId}
        propositionId={propositionId}
      />
      <ClickableMetric
        value={awardCount}
        label="Awards"
        icon="🏆"
        color="text-yellow-600"
        bgColor="bg-yellow-50"
        organizationId={organizationId}
        metricType="awards"
        segmentId={segmentId}
        propositionId={propositionId}
      />
    </div>
  );
}
